import { withLocalState } from 'pyradux';

import ListingsContainer from './Listings.container';
import reducer from './Listings.reducer';
import ListingsSagas from './Listings.sagas';

const withLocalStateOptions = {
  reducer,
  stateKey: 'listings',
  sagas: [ListingsSagas],
};

export default withLocalState(withLocalStateOptions, ListingsContainer);



// WEBPACK FOOTER //
// ./src/app/modules/Ebay/Listings/index.js